var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 64,
    viewBox: "0 0 59 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 19.3009V44.6991C0.90433 45.8579 1.20939 46.9964 1.78882 47.9999C2.36826 49.0036 3.20167 49.8369 4.20526 50.4164L26.1996 63.1155C27.2032 63.695 28.3417 64 29.5005 64C30.6595 64 31.7978 63.695 32.8015 63.1155L54.7958 50.4164C55.7995 49.8369 56.6328 49.0036 57.2123 47.9999C57.7918 46.9964 58.0968 45.8579 58.0968 44.6991V19.3009C58.0968 18.1421 57.7918 17.0036 57.2123 16.0001C56.6328 14.9964 55.7995 14.163 54.7958 13.5836L32.8015 0.884502C31.7978 0.305056 30.6595 0 29.5005 0C28.3417 0 27.2032 0.305056 26.1996 0.884502L4.20526 13.5836C3.20167 14.163 2.36826 14.9964 1.78882 16.0001C1.20939 17.0036 0.90433 18.1421 0.904297 19.3009Z",
    fill: "#009E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 19.3009V44.6991C0.90433 45.8579 1.20939 46.9964 1.78882 47.9999C2.36826 49.0036 3.20167 49.8369 4.20526 50.4164L26.1996 63.1155C27.2032 63.695 28.3417 64 29.5005 64C30.6595 64 31.7978 63.695 32.8015 63.1155L54.7958 50.4164C55.7995 49.8369 56.6328 49.0036 57.2123 47.9999C57.7918 46.9964 58.0968 45.8579 58.0968 44.6991V19.3009C58.0968 18.1421 57.7918 17.0036 57.2123 16.0001C56.6328 14.9964 55.7995 14.163 54.7958 13.5836L32.8015 0.884502C31.7978 0.305056 30.6595 0 29.5005 0C28.3417 0 27.2032 0.305056 26.1996 0.884502L4.20526 13.5836C3.20167 14.163 2.36826 14.9964 1.78882 16.0001C1.20939 17.0036 0.90433 18.1421 0.904297 19.3009Z",
    fill: "url(#success_mark_paint0_radial_12261_368404)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "success_mark_mask0_12261_368404",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 64
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09717 46.6665L4.09727 46.6667C4.44259 47.2648 4.93932 47.7616 5.53766 48.1071C5.53769 48.1071 5.53771 48.1071 5.53774 48.1071L27.532 60.8061L26.1986 63.1155L27.532 60.8061C28.1302 61.1515 28.8088 61.3334 29.4996 61.3334C30.1904 61.3334 30.8689 61.1516 31.4671 60.8061L32.8005 63.1155L31.4672 60.8061L53.4615 48.1071C54.0598 47.7616 54.5565 47.2649 54.902 46.6666L54.9021 46.6664C55.2474 46.0685 55.4292 45.3899 55.4292 44.6991V19.3009C55.4292 18.6101 55.2474 17.9315 54.9021 17.3336L54.902 17.3334C54.5565 16.735 54.0598 16.2383 53.4616 15.893L53.4615 15.8929L31.4672 3.1939C31.4672 3.19388 31.4672 3.19387 31.4672 3.19385C30.8688 2.84844 30.1903 2.66664 29.4996 2.66664C28.8089 2.66664 28.1303 2.84846 27.532 3.19385C27.5319 3.19387 27.5319 3.19388 27.5319 3.1939L5.53766 15.8929L5.53765 15.8929C4.9394 16.2383 4.44264 16.7351 4.09727 17.3333L4.09717 17.3335C3.75186 17.9315 3.57 18.6102 3.56996 19.3009L4.09717 46.6665ZM4.09717 46.6665C3.75186 46.0685 3.57 45.3898 3.56996 44.6991C3.56996 44.699 3.56996 44.699 3.56996 44.699M4.09717 46.6665L3.56996 44.699M3.56996 44.699V19.301V44.699Z",
    stroke: "#143478",
    strokeWidth: 5.33328
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#success_mark_mask0_12261_368404)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.3469,
    cy: 31.1264,
    rx: 35.5549,
    ry: 35.5556,
    fill: "url(#success_mark_paint1_linear_12261_368404)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1308 34.2678C15.8439 32.8016 17.7278 32.3668 19.0114 33.3721L23.9214 37.2178C24.4405 37.6244 25.1834 37.5701 25.6379 37.0925L41.0744 20.8714C41.9782 19.9216 43.4536 19.8082 44.492 20.6088L45.1445 21.1119C46.3562 22.0461 46.4832 23.8275 45.4164 24.9242L26.5667 44.3015C25.6026 45.2926 24.0256 45.339 23.0049 44.4063L15.5513 37.5954C14.7141 36.8304 14.48 35.6058 14.976 34.5859L15.1308 34.2678Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "success_mark_paint0_radial_12261_368404",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5006 32) rotate(90) scale(32 28.5963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EB8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EB8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "success_mark_paint1_linear_12261_368404",
    x1: 29.3469,
    y1: -4.4292,
    x2: 29.3469,
    y2: 66.6819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E48A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AB64"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success_mark.82b4368779069e1f64f4808867d27b53.svg";